import React from 'react';
import './Scenario1.css';
import ReactPlayer from 'react-player';

const Scenario1Video = () => {
    return (
        <div className='Scenario1VideoWrap'>
            <ReactPlayer url='https://youtu.be/BzrFnK9z-nI' controls={true} />
        </div>
    );
}

export default Scenario1Video;